// bread-crumb.constants.ts
export const CUSTOM_ICONS = [
  'Folder',
  'House',
  'FileText',
  'Settings',
  'Users',
  'BarChart3',
  'LayoutDashboard',
  'Wallet',
  'Search',
  'ChevronRight',
  'ChevronLeft',
  'X',
  'Plus',
  'Trash2',
  'Save',
  'Home',
  'User',
  'CreditCard',
  'DollarSign',
  'Check',
  'AlertCircle',
  'CircleArrowLeft',
  'Tags',
  'Shield',
  'BetweenHorizontalEnd',
  'Building2',
  'ArchiveRestore',
  'File',
  'Cloud',
  'Activity',
  'Key',
  'Server',
  'FolderUp',
  'FolderLock',
  'FolderSync',
  'FolderKanban',
  'FolderGit2',
  'SearchCheck',
  'SquareKanban',
  'Users',
  'UserKey',
  'HardDrive',
  'FolderArchive',
  'House',
  'Folder',
  'FileSliders',
  'UserStar',
  'Gauge',
  'File',
  'Vault',
  'MessageSquareDot',
  'Boxes',
  'Receipt',
  'Landmark',
  'LibraryBig',
  'Pen',
  'Eye',
  'Layers',
  'Form',
];
